// TableFooter.jsx

import React from 'react';

// CSS
import './TableFooter.css';

// Components
import TableViewAdd from 'views/table/add/TableViewAdd';

/**
 * TableFooter
 *
 * @returns {ReactNode} The rendered component.
 */
const TableFooter = ({ onAddRow, addLabel, hasMore = false, onLoadMore }) => {

    // ----- RENDER ----- //

    return (
        <div
          className="table-view-add-row"
        >

            {/* LOAD MORE BUTTON */}
            {hasMore ? (
                <button
                  className="table-view-load-more-button"
                  type="button"
                  onClick={onLoadMore}
                >
                    Load More
                </button>
            ) : null}

            <TableViewAdd
              label={addLabel || '+ Add New Row'}
              onClick={onAddRow}
            />
        </div>
    );
};

// Dev Tools
TableFooter.displayName = 'TableFooter';

export default TableFooter;
